import React, { useState } from 'react'

interface CreateAbortControllerOptions {
  beforeClose?: boolean
}

export const closeAbortController = (controller: AbortController) => {
  if (controller) {
    controller.abort()
    window.ABORT_CONTROLLER = null
  }
}

export const createAbortController = (
  options?: CreateAbortControllerOptions
) => {
  if (options?.beforeClose) {
    closeAbortController(window.ABORT_CONTROLLER)
  }
  const abortController = new AbortController()
  window.ABORT_CONTROLLER = abortController
  return abortController
}

export const useAbortController = <Props extends {}>(
  Component: React.ComponentType<Props>
) =>
  React.memo((props: Props) => {
    const [mounted, mount] = useState(false)
    React.useEffect(() => {
      const controller = createAbortController({
        beforeClose: true
      })
      mount(true)
      return function cancel() {
        mount(false)
        closeAbortController(controller)
      }
    }, [])

    return mounted ? <Component {...props} /> : null
  })
